<template>
    <div class="wallet-container">
        <van-nav-bar
                title="我的钱包"
                left-arrow
                left-text="返回"
                @click-left="onClickLeft"
        />
        <div class="amt">
            <van-skeleton
                    title
                    :row="1"
                    :loading="loading"
            >
                <p class="amt-tips">余额（元）</p>
                <p class="amt-je">{{account.balance | money}}</p>
            </van-skeleton>
        </div>
        <div class="func-list">
            <van-cell title="充值" is-link icon="shop-o"/>
            <van-cell title="提现" is-link icon="shop-o"/>
        </div>
        <div class="card">
            <van-skeleton
                    title
                    :row="2"
                    :loading="loading"
            >
                <p class="jba">基本账户</p>
                <p class="accountName">{{account.accountName}}</p>
                <p class="accountNo">{{account.accountNo}}</p>
            </van-skeleton>
        </div>
        <div class="per-list">
            <van-cell title="修改密码" is-link icon="shop-o" @click="goUrl('updatePwd')"/>
        </div>
    </div>
</template>

<script>
    import { Cell, CellGroup, NavBar, Skeleton } from 'vant';
    import utils from '@/utils'
    import api from '@/api'

    export default {
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [NavBar.name]: NavBar,
            [Skeleton.name]: Skeleton
        },
        created() {
            this.setPwdFlag();
            this.getBalance();
        },
        data() {
            return {
                account: {
                    balance:'',
                    accountName: '',
                    accountNo: ''
                },
                loading: true
            }
        },
        mounted() {
            this.loading = true;
        },
        methods: {
            setPwdFlag() {
                utils.storage.set("isCheckedPwd",utils.date.dateFormat());
            },
            goUrl(url){
                this.$router.push('/'+url+'');
            },
            async getBalance() {
                const res = await api.personal.getBalance({});
                if (res.msg === 'success') {
                    const { data } = res;
                    this.loading = false;
                    this.account.balance = data.accountBalanceAmt;
                    this.account.accountName = data.accountName;
                    this.account.accountNo = this.cardInsertBlank(data.accountNo);
                }

            },
            cardInsertBlank(cardNo){
                var len = cardNo.length;
                var reg = /\s{1,}/g;
                var card_ = "";
                var card = cardNo;
                if( len == 0){
                    return '';
                }
                //去除空格
                card = card.replace(reg,"");
                for(var i = 0;i < len;i++){
                    if(i == 3||i == 7 ||i == 11||i == 15){
                        card_ = card_ + card.charAt(i) + " ";
                    }
                    else{
                        card_ = card_ + card.charAt(i);
                    }
                }
                return card_;
            },
            onClickLeft() {
                this.$router.replace({
                    path:'/layout',
                    query:{
                        active:"personal"
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .wallet-container{
        .amt{
            height: 40vw;
            background: -webkit-linear-gradient(top, #0358a8, #198ecc);
            background: linear-gradient(to bottom, #0358a8, #198ecc);
            text-align: left;
            color: #fff;
            padding: 30px 20px;
            .amt-tips{
                font-size: 14px;
                color: #d4d4d4;
            }
            .amt-je{
                padding-top: 1vw;
                font-size: 50px;
            }
            .van-skeleton__content{
                padding-top: 20px;
            }
        }
        .func-list {
            margin: 0 auto;
            box-shadow: 0 0 5px rgba(0, 0, 0, .1);
        }
        .per-list{
            margin-top: 30px;
            box-shadow: 0 0 5px rgba(0, 0, 0, .1);
        }
        .card{
            background: -webkit-linear-gradient(left, #158BE8, #1A66A4);
            background: linear-gradient(to left, #158BE8, #1A66A4);
            padding: 20px;
            margin: 10px;
            border-radius: 10px;
            .jba{
                color: #d4d4d4;
                font-size: 12px;
            }
            .accountName{
                color: #fff;
                margin-top: 8px;
                font-size: 15px;
            }
            .accountNo{
                color: #fff;
                margin-top: 4px;
                font-size: 15px;
            }
        }
    }
</style>